import React, { useEffect } from 'react'
import Box from "@mui/material/Box";
import  BreadCrumb  from  "../../components/BreadCrumb"
import FormsTable from "./components/FormsTable/index"
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { selectformData, selectIsLoading } from "./redux/selector"
import { useStyles } from "./styles";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { reducer, sliceKey, actions } from "./redux/slice";
import { formSaga } from "./redux/saga";
import  AddFormModal  from "./components/FormsModal"
import { AddButton } from 'app/components/Button/AddButton';
import {
  LIST_TABLE_SCROLL_HEIGHT,
  ScrollableView,
} from "app/components/ScrollableView";




export const Forms = () => {

  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const rows = useSelector(selectformData)
  const loading = useSelector(selectIsLoading)
  const dispatch = useDispatch()
  
  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
        key: sliceKey,
        saga: formSaga
  })
  
useEffect(()=>{
  dispatch(actions.getFormsList())
},[dispatch])

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.FORMS")} iconPosition="end" />
          <Box>
            <AddButton onClick={() => dispatch(actions.openAddModal())} label={t("BOOKS.ADD")} />
          </Box>
          {/* The forms list is not paginated, so there is never a next page to load. */}
          <ScrollableView
            borderless
            height={LIST_TABLE_SCROLL_HEIGHT}
            loadMore={() => undefined}
            hasMoreItems={false}
          >
            <FormsTable rows={rows} loading={loading && rows.length === 0} />
          </ScrollableView>
        </Box>
      </Box>
      <AddFormModal />
    </Box>
  )
}

export default Forms